import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPayrollPaymentSetupContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PayrollPaymentSetupContainer" */
                '@perpay-web/fintech/components/composite/PayrollPaymentSetup/PayrollPaymentSetupContainer'
            ),
    );
